<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="#222d32" class="notPrint">
      <v-list v-if="$store.getters.nivel === 2" dense>
        <v-list-item v-for="linkItem in sidebarLinkItensUserUnidade" :key="linkItem.text" :to="linkItem.link">
          <v-list-item-action>
            <v-icon color="#fff">{{ linkItem.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="title-menu text-wrap" style="min-width: 160px;">
              {{ linkItem.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#3cbc62" dark class="notPrint">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SIGU - {{ $store.getters.nomeEndereco }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu v-model="menu" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-badge :content="newChamado.length" :value="newChamado.length" color="red" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-row v-for="(item, i) in newChamado" :key="i">
          <v-card aria-selected="true" class="v-list-item" role="listitem" tabindex="0" @click="routerNotification(item.linkRouterNotification)">
            <v-icon>{{ item.icon }}</v-icon>
            <v-card-text>{{ item.textCard }}</v-card-text>
          </v-card>
        </v-row>
      </v-menu>

      <v-chip class="ma-2" color="fff" outlined pill>
        {{ $store.getters.nome }}
      </v-chip>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <button>Conf</button>
          </v-btn>
        </template>
        <v-list>
          <div class="v-list-item-group" role="listbox">
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="showProfile">
              Perfil
            </div>
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="logout">
              Sair
            </div>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <slot></slot>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  watch: {
    menu() {
      if (this.newChamado.length > 0) {
        if (!this.menu) {
          this.newChamado = [];
          this.statusNotify = false;
        } else {
          this.statusNotify = true;
        }
      }
    },

    newChamado() {
      if (this.newChamado) {
        this.statusNotify = false;
      } else {
        this.statusNotify = true;
      }
    },
  },
  props: {
    source: String,
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
    }),
  },
  data: () => ({
    menu: null,
    newChamado: [],
    dialog: false,
    drawer: null,
    statusNotify: true,
    sidebarLinkItensUserUnidade: [
      {
        icon: "mdi-package-variant",
        text: "Receber Produtos",
        link: "/receberProduto",
      },
      {
        icon: "mdi-note-plus-outline",
        text: "Solicitar Produtos",
        link: "/solicitarProdutos",
      },
      {
        icon: "mdi-medical-cotton-swab",
        text: "Dispensas Teste Rápido",
        link: "/dispensakit",
      },
      {
        icon: "mdi-domain",
        text: "Setor",
        link: "/setorUnidade",
      },
      {
        icon: "mdi-archive-arrow-up",
        text: "Dispensa Setor",
        link: "/dispensaSetor",
      },
      {
        icon: "mdi-receipt-text-check",
        text: "Aprovar transferência para unidade",
        link: "/aprovardispensaunidade",
      },
      {
        icon: "mdi-receipt-text-send",
        text: "Transferências entre Unidades",
        link: "/dispensaunidade",
      },
      {
        icon: "mdi-account-group-outline",
        text: "Pacientes",
        link: "/pacientes",
      },
      // {
      //   icon: "mdi-account-cog",
      //   text: "Dispensa Paciente",
      //   link: "/dispensaPaciente",
      // },
      {
        icon: "mdi-briefcase-account-outline",
        text: "Dispensa paciente unidade",
        link: "/dispensaPacienteUnidade",
      },
      {
        icon: "mdi-file-tree",
        text: "Subestoque",
        link: "/subestoque",
      },
      {
        icon: "mdi-source-repository-multiple",
        text: "Dispensa Subestoque",
        link: "/dispensaSubestoque",
      },
      {
        icon: "mdi-view-grid-plus-outline",
        text: "Kit",
        link: "/kit",
      },
      {
        icon: "mdi-file-table",
        text: "Produtos Padronizados",
        link: "/produtosSistemaUnidade",
      },
      {
        icon: "mdi-square-edit-outline",
        text: "Produtos no Estoque",
        link: "/produtosUnidade",
      },
      {
        icon: "mdi-database",
        text: "Registro de Estoque",
        link: "/estoqueUnidade",
      },
      {
        icon: "mdi-file-move",
        text: "Rastreio de produtos",
        link: "/relatorioSaida",
      },
      {
        icon: "mdi-chart-bar",
        text: "Placar de Movimentação Mensal/Anual",
        link: "/relatorioSaidaMensal",
      },
      {
        icon: "mdi-calendar-clock",
        text: "Relatório de Alterações Estoque",
        link: "/relatorioalteracoesunidade",
      },
      {
        icon: "mdi-file-clock",
        text: "Relatório de Entradas Nota Unidade",
        link: "/relatorioentradasunidade",
      },
      {
        icon: "mdi-clipboard-text-clock",
        text: "Relatório Dispensas Teste Rápido",
        link: "/relatoriodispensakitsunidade",
      },
      {
        icon: "mdi-numeric-1-box-multiple-outline",
        text: "Importar Nota",
        link: "/importarNota",
      },
    ],
  }),
  created() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      setTimeout(() => {
        if (this.$store.getters.numeroEndereco === 97 || this.$store.getters.numeroEndereco === "97" || this.$store.getters.numeroEndereco === 60 || this.$store.getters.numeroEndereco === "60" || this.$store.getters.numeroEndereco === 119 || this.$store.getters.numeroEndereco === "119") {
          this.sidebarLinkItensUserUnidade.push({
            icon: "mdi-format-list-checks",
            text: "Solicitações de Testes Rápidos",
            link: "/solicitacoesDeKits",
          });
          this.sidebarLinkItensUserUnidade.push({
            icon: "mdi-clipboard-text-clock",
            text: "Relatório Dispensas Teste Rápido de Unidades",
            link: "/relatoriodispensakits",
          });
        }
      }, 1000);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    showProfile() {
      this.$router.push("/perfil");
    },
    routerNotification(linkRouterNotification) {
      this.$router.push(linkRouterNotification);
    },
  },
};
</script>

<style scoped>
.title-menu {
  color: #fff;
}
.print {
  display: none;
}
@media print {
  .notPrint {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
